import { Sun, Moon } from 'lucide-react';
import { useState, useEffect } from 'react';
import { toast } from 'sonner';

const ThemeToggle = ({ isPremium = false }) => {
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem('theme') || 'dark';
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === 'light') {
      root.classList.remove('dark');
      root.classList.add('light');
    } else {
      root.classList.remove('light');
      root.classList.add('dark');
    }
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => {
    if (!isPremium && theme === 'dark') {
      toast.info('Modo claro es una funcion Premium. Actualiza tu plan.');
      return;
    }
    setTheme(theme === 'dark' ? 'light' : 'dark');
  };

  return (
    <button
      data-testid="theme-toggle-btn"
      onClick={toggleTheme}
      className="relative w-10 h-6 sm:w-16 sm:h-8 rounded-full bg-zinc-800/50 border border-zinc-700/50 transition-all duration-300 hover:border-zinc-600 focus:outline-none focus:ring-2 focus:ring-indigo-500/50"
      aria-label="Toggle theme"
    >
      <div
        className={`absolute top-0.5 left-0.5 sm:top-1 sm:left-1 w-5 h-5 sm:w-6 sm:h-6 rounded-full bg-gradient-to-br transition-all duration-300 flex items-center justify-center ${
          theme === 'dark'
            ? 'translate-x-0 from-indigo-500 to-violet-600'
            : 'translate-x-4 sm:translate-x-8 from-yellow-400 to-orange-500'
        }`}
      >
        {theme === 'dark' ? (
          <Moon className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-white" strokeWidth={2} />
        ) : (
          <Sun className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-white" strokeWidth={2} />
        )}
      </div>
      {!isPremium && (
        <span className="absolute -top-1 -right-1 w-3 h-3" />
      )}
    </button>
  );
};

export default ThemeToggle;
